/**
 * Active page (tab) derived from current URL. No Redux.
 * Same values as PAGE_NAME / NAVIGATION_PAGE (HOME, ALL_DOCUMENTS, CHECK_IN_FROM_TEAMS).
 */
import { useLocation } from "react-router-dom";
import { getNavKeyFromPath } from "../../routes/routeConfig";

export function useActivePage() {
  const location = useLocation();
  return getNavKeyFromPath(location.pathname || "", location.state);
}
